import React from "react";
import { Outlet } from "react-router-dom";
import './timesheet.scss';

const Timesheet = () => {
    return (
        <div className="timesheets">
            <Outlet />
        </div>
    )
}

export default Timesheet;